import BaseService from "./BaseService";
import http from "./HttpService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin";
const apiGetEndpoint = API_BASE_URL_ENV() + "/admin/admin";
const apiTogglle = API_BASE_URL_ENV() + "/admin/block";
const apiDashboard = API_BASE_URL_ENV() + "/dashboard/stats";
const apiLogout = API_BASE_URL_ENV() + "/admin/logout";
const apiImageProfile = API_BASE_URL_ENV() + "/admin/imageProfile";

export default class AdminService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	updateProfile(data) {
		const body = { ...data };
		return http.put(apiEndpoint, body);
	}

	getList(params) {
		if (params) {
			return http.get(`${apiGetEndpoint}`, { params });
		} else {
			return http.get(`${apiGetEndpoint}`);
		}
	}

	getDashboard = () => {
		return http.get(apiDashboard);
	};

	changeAvatar = (data) => {
		return http.put(apiImageProfile, data);
	};

	toggleStatus(id, data) {
		return http.put(`${apiTogglle}/${id}`, data);
	}

	logout() {
		return http.post(apiLogout);
	}
}
